import { render, staticRenderFns } from "./quotation-info-brand-intro.vue?vue&type=template&id=6fc3109b"
import script from "./quotation-info-brand-intro.vue?vue&type=script&lang=js"
export * from "./quotation-info-brand-intro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc3109b')) {
      api.createRecord('6fc3109b', component.options)
    } else {
      api.reload('6fc3109b', component.options)
    }
    module.hot.accept("./quotation-info-brand-intro.vue?vue&type=template&id=6fc3109b", function () {
      api.rerender('6fc3109b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-info-brand-intro.vue"
export default component.exports